var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{on:{"click":function($event){return _vm.dealShare($event,'qqim')}}},[_vm._v("qq")]),_c('div',{on:{"click":function($event){return _vm.dealShare($event,'weixin')}}},[_vm._v("wx")]),_c('div',{on:{"click":function($event){return _vm.dealShare($event,'sinaminiblog')}}},[_vm._v("wb")])])
}
var staticRenderFns = []

export { render, staticRenderFns }